import {
  BoltTaskRuleTypes,
  IBoltTaskRule,
  INewBoltTaskRule,
  useBoltApiClient,
} from "@bolt/core";
import {
  AppToasterV2,
  FieldFormV2,
  FieldFormV2Module,
  Footer,
  ActionButtons,
  SchemaFactoryV2,
  useFieldSchemaV2,
} from "@ucl/library";
import { RefObject, useEffect, useRef, useState } from "react";
import { createBoltTaskRuleBuilder } from "./builders/createBoltTaskRuleBuilder";
import { QueryBuilderComponent } from "@syncfusion/ej2-react-querybuilder";
import { createBoltTaskApiClient } from "../../lib/apiClients/boltTaskApiClient";

export interface CreateBoltTaskRuleFormProps {
  // extends BoltInteraction<
  //   {
  //     onSubmitSuccessfully: (taskRule: INewBoltTaskRule) => Promise<void>;
  //   },
  //   {}
  //> {
  apiBaseUrl: string;
  getAuthRequestHeader: () => Promise<Record<string, string>>;
  // currentUser: { id: string };
  onSave?: () => void;
  onCancel?: () => void;
}

export const CreateBoltTaskRuleForm: React.FC<CreateBoltTaskRuleFormProps> = ({
  apiBaseUrl,
  getAuthRequestHeader,
  //actions,
  onSave,
  onCancel,
}) => {
  const boltApiClient = useBoltApiClient();
  const [localTaskRule, _setLocalTaskRule] = useState<
    IBoltTaskRule | INewBoltTaskRule
  >();
  const taskFormRef: RefObject<FieldFormV2Module<INewBoltTaskRule> | null> =
    useRef<FieldFormV2Module<INewBoltTaskRule>>(null);
  const queryBuilderRef = useRef<QueryBuilderComponent>(null);

  const [schemaFactory, setSchemaFactory] = useState<SchemaFactoryV2>();

  const { getAsyncSchemaFactory } = useFieldSchemaV2("tasks/field-schema");
  const loadingRef = useRef<boolean>(false);

  const getSchema = async () => {
    if (loadingRef.current) {
      return;
    }

    loadingRef.current = true;
    setSchemaFactory(await getAsyncSchemaFactory(boltApiClient));
  };

  useEffect(() => {
    if (loadingRef.current) {
      loadingRef.current = false;
    }
  }, [schemaFactory]);

  useEffect(() => {
    getSchema();
  }, []);

  const taskApiClient = createBoltTaskApiClient(boltApiClient);

  const handleSubmit = async (taskRule: INewBoltTaskRule) => {
    //const taskRuleCondition = queryBuilderRef.current?.getRules();

    await taskApiClient.createTaskRule({
      ...taskRule,
      // ...(taskRule.taskRuleType === BoltTaskRuleTypes.Event && {
      //   eventCondition: {
      //     ...taskRule.eventCondition,
      //     rule: taskRuleCondition,
      //   },
      // }),
      // ...(taskRule.taskRuleType === BoltTaskRuleTypes.Time && {
      //   timeCondition: {
      //     ...taskRule.timeCondition,
      //     rule: taskRule.timeCondition?.rule.substring(
      //       0,
      //       taskRule.timeCondition?.rule.length - 1
      //     ),
      //   },
      // }),
    } as INewBoltTaskRule);

    AppToasterV2.showSuccessAppToaster("Create task rule successfully.");
    onSave?.();
  };

  return (
    <div className="task-rule-form">
      {schemaFactory && (
        <FieldFormV2<INewBoltTaskRule>
          ref={
            taskFormRef as RefObject<FieldFormV2Module<INewBoltTaskRule> | null>
          }
          fieldSchemaFormBuilder={createBoltTaskRuleBuilder(schemaFactory, {
            taskTypeProps: {
              apiBaseUrl: apiBaseUrl,
              getAuthRequestHeader: getAuthRequestHeader,
            },
            taskRuleTypeProps: {
              optionValues: (schemaFactory.schema as any).enumOptions
                .BoltTaskRuleTypes,
            },
            eventConditionProps: {
              hidden: true,
              apiBaseUrl: apiBaseUrl,
              getAuthRequestHeader: getAuthRequestHeader,
              queryBuilderRef: queryBuilderRef,
            },
            timeConditionProps: {
              hidden: localTaskRule?.taskRuleType == BoltTaskRuleTypes.Event,
            },
          })}
          value={localTaskRule}
          onFormSubmit={handleSubmit}
          columns={3}
        />
      )}
      <Footer className="task-rule-form-footer">
        <ActionButtons
          actions={[
            {
              text: "Cancel",
              onActionClick: onCancel,
            },
            {
              text: "Create",
              isPrimary: true,
              onActionClick: () => {
                taskFormRef.current?.submit();
              },
            },
          ]}
        />
      </Footer>
      {/* <div className="task-rule-form-footer">
        <div className="task-rule-form-footer-cta-wrapper">
          <PrimaryButton
            text="Create Task Rule"
            onClick={() => {
              taskFormRef.current?.submit();
            }}
          />
        </div>
      </div> */}
    </div>
  );
};
